import * as React from 'react';
import { FC, useEffect } from 'react';

import { styled } from '../theme';
import { FlexRow, PageCard } from './';

type Props = {
    withTabs?: boolean;
    noHeader?: boolean;
    noPadding?: boolean;
    headerHeight?: number;
    noScrolling?: boolean;
    transparentSurface?: boolean;
    innerRef?: any;
    children?: React.ReactNode;
    id?: string;
    onMountedChange?: (boolean) => void;
};

const SpaceUnderPageHeader = styled(FlexRow)<Props>(
    ({ theme, noHeader, headerHeight = 100, withTabs }) => ({
        width: '100%',
        minHeight: noHeader ? 0 : withTabs ? headerHeight + 50 : headerHeight,
        [theme.breakpoint.md]: {
            minHeight: noHeader ? 0 : withTabs ? headerHeight + 50 : headerHeight,
        },
    })
);

const Container = styled('section')<Props>(({ theme, noPadding, noScrolling }) => {
    const padding = noPadding ? 0 : 15;
    const mdPadding = padding * 2;

    return {
        width: '100%',
        flexGrow: 1,
        background: theme.color.backgroundGray,
        overflowY: noScrolling ? 'unset' : 'auto',
        display: 'flex',
        flexFlow: 'column',
        padding: padding,
        paddingTop: mdPadding,
        [theme.breakpoint.md]: {
            padding: mdPadding,
            paddingTop: mdPadding,
        },
    };
});

const PageBody: FC<Props> = ({
    onMountedChange,
    children,
    transparentSurface,
    innerRef,
    ...restProps
}) => {
    const { noHeader, headerHeight, withTabs } = restProps;

    useEffect(() => {
        onMountedChange?.(true);
        return () => {
            onMountedChange?.(false);
        };
    });

    return (
        <>
            <SpaceUnderPageHeader {...{ noHeader, headerHeight, withTabs }} />
            <Container ref={innerRef} {...restProps}>
                <PageCard transparentSurface={transparentSurface}>{children}</PageCard>
            </Container>
        </>
    );
};

export default PageBody;
